import React, {useEffect, useState} from "react";
import "./navbarMobileAuth.scss";
import BtnCircular from "../../../ds/BtnCircular/BtnCircular";
import { ReactComponent as CloseIcon } from "../../../icons/x.svg";
import { ReactComponent as LangIcon } from "../../../icons/lang.svg";
import { useLanguages } from "../../../hooks/content";

const NavbarMobileAuth = ({ cancelClick, showCloseButton= true,  showLanguageSelector = false }) => {
    const initialLanguage = localStorage.getItem("language") || "ka";
    const [currentLanguage, setCurrentLanguage] = useState(initialLanguage);

    const { refetchLang } = useLanguages();
    const changeLanguage = () => {
        const newLanguage = currentLanguage === "en" ? "ka" : "en";
        setCurrentLanguage(newLanguage);
        localStorage.setItem("language", newLanguage);
    };
    useEffect(() => {
        refetchLang();
        // eslint-disable-next-line
    }, [currentLanguage]);

  return (
    <div className="navbar">
      <img src="/images/icons/gz-lg.png" alt="" className="gz-icon" />

        {
            showLanguageSelector && (
                <BtnCircular
                    size={"md"}
                    mainColor={"grayBorder"}
                    svg={<LangIcon />}
                    disabled={false}
                    mode={""}
                    onClick={changeLanguage}
                />
            )
        }

        {
            showCloseButton && (
                <BtnCircular
                    size={"md"}
                    mainColor={"white"}
                    svg={<CloseIcon />}
                    disabled={false}
                    mode={""}
                    onClick={cancelClick}
                />
            )
        }
    </div>
  );
};

export default NavbarMobileAuth;
